export const ORIGIN_URL = window.location.origin;

export const API_BASE_URL = `${ORIGIN_URL}/api`;
export const TCA_PATH = "/tca";

const rp = (path) => `${TCA_PATH}${path}`;

export const PRODUCTS = {
    TCA: "tca",
};

export const UNKNOWN = "Unknown";

export const UNSPECIFIED = "Unspecified";

export const PAGES = {
    CLIENT_ORDER_PAGES: {
        SUMMARY: {
            Code: "co_summary",
            RoutePath: rp`/co/summary`,
        },
        BROKER_USAGE: {
            Code: "co_broker_usage",
            RoutePath: rp`/co/broker/usage`,
        },
        BROKER_USAGE_TIMESERIES: {
            Code: "co_broker_usage_timeseries",
            RoutePath: rp`/co/broker/usage/timeseries`,
        },
        BROKER_SUMMARY: {
            Code: "co_broker_summary",
            RoutePath: rp`/co/broker/summary`,
        },
        BROKER_SUMMARY_TIMESERIES: {
            Code: "co_broker_summary_timeseries",
            RoutePath: rp`/tca/co/broker/summary/timeseries`,
        },
        BROKER_PERFORMANCE: {
            Code: "co_broker_performance",
            RoutePath: rp`/co/broker/performance`,
        },
        BROKER_PERFORMANCE_TIMESERIES: {
            Code: "co_broker_performance_timeSeries",
            RoutePath: rp`/co/broker/performance/timeseries`,
        },
        BROKER_LIQUIDITY: {
            Code: "co_broker_liquidity",
            RoutePath: rp`/co/broker/liquiditycapture`,
        },
        BROKER_LIQUIDITY_TIMESERIES: {
            Code: "co_broker_liquidity_timeSeries",
            RoutePath: rp`/co/broker/liquiditycapture/timeseries`,
        },
        BROKER_ORDERTYPEANALYSIS: {
            Code: "co_broker_orderTypeAnalysis",
            RoutePath: rp`/co/broker/ordertypeanalysis`,
        },
        BROKER_ORDERTYPE_TIMESERIES: {
            Code: "co_broker_orderType_timeSeries",
            RoutePath: rp`/co/broker/ordertypeanalysis/timeseries`,
        },
        TRADER_SUMMARY: {
            Code: "co_trader_summary",
            RoutePath: rp`/co/trader/summary`,
        },
        TRADER_SUMMARY_TIMESERIES: {
            Code: "co_trader_summary_timeseries",
            RoutePath: rp`/co/trader/timeSeries`,
        },
        TRADER_USAGE: {
            Code: "co_trader_usage",
            RoutePath: rp`/co/trader/usage`,
        },
        TRADER_USAGE_TIMESERIES: {
            Code: "co_trader_usage_timeseries",
            RoutePath: rp`/co/trader/usage/timeseries`,
        },
        TRADER_LIQUID_CAPTURE: {
            Code: "co_trader_liquid_capture",
            RoutePath: rp`/co/trader/liquidcapture`,
        },
        TRADER_LIQUIDITY_TIMESERIES: {
            Code: "co_trader_liquidity_timeseries",
            RoutePath: rp`/co/trader/liquiditycapture/timeseries`,
        },
        TRADER_ORDER_TYPE: {
            Code: "co_trader_order_type",
            RoutePath: rp`/co/trader/ordertype`,
        },
        TRADER_ORDERTYPE_TIMESERIES: {
            Code: "co_trader_orderType_timeseries",
            RoutePath: rp`/co/trader/ordertypeanalysis/timeseries`,
        },
        TRADER_PERFORMANCE: {
            Code: "co_trader_performance",
            RoutePath: rp`/co/trader/performance`,
        },
        TRADER_PERFORMANCE_TIMESERIES: {
            Code: "co_trader_performance_timeseries",
            RoutePath: rp`/co/trader/performance/timeseries`,
        },
        ORDER_LIST: {
            Code: "co_list",
            RoutePath: rp`/co/list`,
        },
        ORDER_OUTLIER: {
            Code: "co_outlier",
            RoutePath: rp`/co/outlier`,
        },
    },
    SUB_ORDER_PAGES: {
        SUMMARY: {
            Code: "so_summary",
            RoutePath: rp`/so/summary`,
        },
        ORDER_LIST: {
            Code: "so_list",
            RoutePath: rp`/so/list`,
        },
        ORDER_OUTLIER: {
            Code: "so_outlier",
            RoutePath: rp`/so/outlier`,
        },
    },
    SCORECARD: {
        BROKER_SUMMARY: {
            Code: "scorecard_broker",
            RoutePath: rp`/scorecard/broker`,
        },
        BROKER_LIMIT: {
            Code: "scorecard_broker_limit",
            RoutePath: rp`/scorecard/broker/limit`,
        },
        ALGO_SUMMARY: {
            Code: "scorecard_algo",
            RoutePath: rp`/scorecard/algo`,
        },
        ALGO_LIMIT: {
            Code: "scorecard_algo_limit",
            RoutePath: rp`/scorecard/algo/limit`,
        },
    },
    EXECUTIONS_PAGES: {
        SUMMARY: {
            Code: "executions_summary",
            RoutePath: rp`/executions/summary`,
        },
        EXECUTIONS_LIST: {
            Code: "executions_list",
            RoutePath: rp`/executions/list`,
        },
        OUTLIER: {
            Code: "executions_outlier",
            RoutePath: rp`/executions/outlier`,
        },
        HEATMAP: {
            Code: "executions_heatmap",
            RoutePath: rp`/executions/heatmap`,
        },
    },
    ALLOCATIONS_PAGES: {
        LIST: {
            Code: "client_order_allocations_overview_list",
            RoutePath: rp`/co/allocations/list`,
        },
        SUMMARY: {
            Code: "co_allocations_summary",
            RoutePath: rp`/co/allocations/summary`,
        },
        INDIVIDUAL_REPORT: {
            Code: "co_allocations_report",
            RoutePath: rp`/co/allocations/report`,
        },
        SO_LIST: {
            Code: "sub_order_allocations_overview_list",
            RoutePath: rp`/so/allocations/list`,
        },
        SO_SUMMARY: {
            Code: "so_so-allocations_summary",
            RoutePath: rp`/so/so-allocations/summary`,
        },
        SO_INDIVIDUAL_REPORT: {
            Code: "so_so-allocations_report",
            RoutePath: rp`/so/so-allocations/report`,
        },
    },

    getMessageTypeByRoutePath: function (routePath) {
        return "clientOrder";
    },
};
